import {Injectable} from '@angular/core';
import {DateRange, MatDateRangeSelectionStrategy} from '@angular/material/datepicker';
import {DateAdapter} from "@angular/material/core";

@Injectable()
export class ThirtyDayRangeSelectionStrategy<D> implements MatDateRangeSelectionStrategy<D> {
  constructor(private _dateAdapter: DateAdapter<D>) {
  }

  selectionFinished(date: D | null): DateRange<D> {
    return this._createThirtyDayRange(date);
  }

  createPreview(activeDate: D | null): DateRange<D> {
    return this._createThirtyDayRange(activeDate);
  }

  private _createThirtyDayRange(date: D | null): DateRange<D> {
    if (date) {
      const start = date;
      const thirtyDaysLater = this._dateAdapter.addCalendarDays(date, 30);
      const today = this._dateAdapter.today();

      const end = this._dateAdapter.compareDate(thirtyDaysLater, today) > 0 ? today : thirtyDaysLater;
      return new DateRange<D>(start, end);
    }
    return new DateRange<D>(null, null);
  }
}
